export default {"src":"/_next/static/media/drip_64.cbf7e455.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};